export const assignmentsColumns = {
    startDate: 'StartDate',
    status: 'Status',
    productName: 'ProductName',
    name: 'name',
    dueDate: 'DueDate',
};

export const sortDirection = {
    ascending: 'asc',
    descending: 'desc'
};
